import React from "react";
import { ReceiptText } from "lucide-react";
import HRISListPage from "../../../HRISListPage";
import "../../../hrisDummyData";

import {
  getEmployeeAdvances,
  createEmployeeAdvance,
  updateEmployeeAdvance,
  deleteEmployeeAdvance,
  getEmployeeList,
} from "../../../hrisApi";

const STATUS_OPTIONS = [
  "Draft",
  "Submitted",
  "Approved",
  "Rejected",
  "Cancelled",
];

const columns = [
  { key: "id", label: "ID" },
  { key: "employeeName", label: "Employee" },
  { key: "postingDate", label: "Date" },
  {
    key: "advanceAmount",
    label: "Amount",
    render: (v) => `Rp ${Number(v || 0).toLocaleString("id-ID")}`,
  },
  { key: "company", label: "Company" },
  { key: "status", label: "Status", badge: true },
];

const formFields = [
  {
    key: "series",
    label: "Series",
    type: "text",
    required: true,
    defaultValue: "HR-EAD-.YYYY.-",
    layout: "half",
  },
  {
    key: "postingDate",
    label: "Posting Date",
    type: "date",
    required: true,
    layout: "half",
  },
  {
    key: "employeeName",
    label: "Employee",
    type: "select",
    required: true,
    optionsLoader: getEmployeeList,
    layout: "half",
  },
  {
    key: "company",
    label: "Company",
    type: "text",
    required: true,
    placeholder: "Company name",
    layout: "half",
  },

  {
    type: "section",
    label: "Purpose & Amount",
    fullWidth: true,
  },

  {
    key: "purpose",
    label: "Purpose",
    type: "textarea",
    required: true,
    placeholder: "Purpose of advance request",
  },
  {
    key: "advanceAmount",
    label: "Advance Amount",
    type: "currency",
    required: true,
  },

  {
    type: "section",
    label: "Accounting",
    fullWidth: true,
  },
  {
    key: "advanceAccount",
    label: "Advance Account",
    type: "text",
    placeholder: "Employee Advances Account",
  },
  {
    key: "modeOfPayment",
    label: "Mode of Payment",
    type: "select",
    options: ["Cash", "Bank Transfer", "Cheque", "Petty Cash"],
  },
  {
    key: "repayUnclaimedAmountFromSalary",
    label: "Repay Unclaimed Amount From Salary",
    type: "select",
    options: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    defaultValue: true,
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: STATUS_OPTIONS,
    defaultValue: "Draft",
  },
];

const EmployeeAdvance = () => (
  <HRISListPage
    title="Employee Advances"
    description="Manage employee advance requests."
    icon={<ReceiptText />}
    columns={columns}
    fetchData={getEmployeeAdvances}
    createData={createEmployeeAdvance}
    updateData={updateEmployeeAdvance}
    deleteData={deleteEmployeeAdvance}
    formFields={formFields}
    entityName="Employee Advance"
    searchPlaceholder="Search by ID or employee..."
  />
);

export default EmployeeAdvance;
